import { Stack } from "@mui/material";

export const FtiBilingualText = ({ en, th }) => (
  <Stack>
    <span>{en}/</span>
    <span>{th}</span>
  </Stack>
);
